import React, {Component} from 'react';
import {Rate} from 'antd';

/**
 * 评分
 */
class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {data} = this.props;

        return (
            <div>
                <Rate
                  disabled={(data.purpose && data.purpose !== "edit")}
                  {...this.props.option}
                  onChange={(value) => {
                      this.props.verification(this.props.data, value)
                  }}/>
            </div>
        );
    }
}


export default  Index;
